import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCircle as unselectedIcon } from '@fortawesome/free-regular-svg-icons';
import { faCircle as selectedIcon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Restricted from '../../contexts/PermissionProvider/RestrictedWrapper';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import { generateFieldId } from '../../utilities/GenerateFieldId';
import Badge from '../badge/badge';
import Tooltip from '../Tooltip/Tooltip';

function SubmenuItem({ children, onClick }) {
    return (
        <li onClick={onClick}>
            {children}
        </li>
    );
}

type Props = {
    isVisible: boolean,
    menu: any[],
    parent: any,
    onClick: (parentIndex, item) => void,
    currentPage: any,
    isParentRoute: boolean,
}

const Submenu: FC<Props> = ({ isVisible = false, menu = [], parent, onClick, currentPage, isParentRoute = false }) => {
    const { translate } = useLocale();
    const { pathname } = useLocation();
    const [menuItems, setMenuItems] = useState(menu.map((item) => ({ ...item, selected: false })));
    function handleClick(item, index) {
        setMenuItems(menuItems => menuItems.map((item, i) => ({
            ...item,
            selected: index === i
        })));
        onClick(parent, item);
    }

    useEffect(() => {
        setMenuItems(menu)

    }, [menu, isVisible])
    
    return (
        <ul>
            {(isVisible) && menuItems.map((item, i) => (
                <Restricted key={`submenuItem${i}`} to={`show.${item.route}.element`}>
                    <SubmenuItem key={`submenuItem${i}`} onClick={() => handleClick(item, i)}>
                        <div className="ml-1 pl-6 pr-4 h-10 flex flex-row justify-start items-center m-0 p-0 text-white text-sm">
                            <div className="flex flex-col h-full">
                                <div className="border-l w-0 h-full border-sidemenu-tree" />
                            </div>
                            <div className="flex flex-col">
                                <div className="my-2 flex flex-row justify-start items-center">
                                    <div className="ml-0 h-0 w-6 border-t border-sidemenu-tree" />
                                    <div  style={{ textOverflow: 'ellipsis' }} className="cursor-pointer flex flex-row">
                                        <div className="text-base">
                                            {item.route === currentPage && !isParentRoute
                                                ? <FontAwesomeIcon className="ml-0 text-portal-blue-primary-shade2" icon={selectedIcon} />
                                                : <FontAwesomeIcon className="ml-0 text-sidemenu-tree" icon={unselectedIcon as IconDefinition} />
                                            }
                                        </div>                                        
                                            <Tooltip text={translate.byKey(TranslationKeys[item.translationKey])} direction='bottom' show={true}>
                                                <span  className="mt-px w-32 inline-block ml-2 menu-item mr-px break-words" id={generateFieldId(item.name)}>
                                                    {translate.byKey(TranslationKeys[item.translationKey])}
                                                </span>
                                            </Tooltip>                                                                           
                                        {item.badge
                                            ? <div>
                                                <Badge fgColor="white" bgColor="sidemenu-badge">{item.badge}</Badge>
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SubmenuItem>
                </Restricted>
            ))}
        </ul>
    );
}

export default Submenu;
